@if (timeSpent$ | async; as t) {
    @if (bigTimer) {
        <div class="col justify-content-center align-items-center">
            <h3>Pasūtījums nr. {{ activeWorkTime.work.orders.number }}</h3>
            <div class="row align-items-center justify-content-center">
                <h1>
                    <span>{{ formatTimePart(t.hoursElapsed) }}:</span>
                    <span>{{ formatTimePart(t.minutesElapsed) }}:</span>
                    <span>{{ formatTimePart(t.secondsElapsed) }}</span>
                </h1>
            </div>
            <div class="row align-items-center justify-content-center mt-3">
                <button nz-button nzType="primary" nzDanger (click)="stopTimer()">
                    <span nz-icon nzType="stop" nzTheme="outline"></span>
                </button>
                <button *hasPermission="[GroupPermission.WORK_TIME_ADMIN]" nz-button nzType="primary" class="ml-3" (click)="editWorkTime()">
                    <span nz-icon nzType="edit" nzTheme="outline"></span>
                </button>
            </div>
        </div>
    } @else {
        <div class="col justify-content-center align-items-center">
            <h3>Pasūtījums nr. {{ activeWorkTime.work.orders.number }}</h3>
            <div class="row align-items-center justify-content-center">
                <h1>
                    <span>{{ formatTimePart(t.hoursElapsed) }}:</span>
                    <span>{{ formatTimePart(t.minutesElapsed) }}:</span>
                    <span>{{ formatTimePart(t.secondsElapsed) }}</span>
                </h1>
                <button nz-button nzType="primary" nzDanger class="ml-2" (click)="stopTimer()">
                    <span nz-icon nzType="stop" nzTheme="outline"></span>
                </button>
                <button *hasPermission="[GroupPermission.WORK_TIME_ADMIN]" nz-button nzType="primary" class="ml-2" (click)="editWorkTime()">
                    <span nz-icon nzType="edit" nzTheme="outline"></span>
                </button>
            </div>
        </div>
    }
}
